import React from 'react';
import CollapsibleListField from '../../../puck/fields/CollapsibleListField';
import InspectorRow from '../../../puck/fields/InspectorRow';
import IconPickerField from '../../../puck/fields/IconPickerField';

/**
 * Champ « Étapes » — liste repliable partagée. Titre, date et description
 * s'éditent sur le canvas : ne restent ici que les attributs atomiques.
 */
export default function TimelineStepsField({ value, onChange }) {
  return (
    <CollapsibleListField
      value={value}
      onChange={onChange}
      addLabel="Ajouter une étape"
      createItem={(count) => ({
        title: `Étape ${count + 1}`,
        date: '',
        description: '',
        icon: '',
      })}
      itemTitle={(item, index) => String(item.title || '').replace(/<[^>]+>/g, '').trim()
        || `Étape ${index + 1}`}
      renderItem={(item, update) => (
        <InspectorRow label="Icône">
          <IconPickerField
            value={item.icon || ''}
            onChange={(icon) => update({ icon })}
          />
        </InspectorRow>
      )}
    />
  );
}
